import React from 'react';
import { DrawerHeader as Header, DrawerTitle, Button, } from '@one-thd/sui-atomic-components';
import { ArrowBack } from '@one-thd/sui-icons';
const DrawerHeader = ({ showBackButton, title, onClose, onBack, }) => {
    const BackButton = () => (React.createElement(Button, { "aria-label": "back", variant: "ghost", startIcon: ArrowBack, onClick: () => {
            if (onBack)
                onBack();
        } }, "Back"));
    return ((showBackButton && (React.createElement(Header, { onClose: onClose, startAdornment: React.createElement(BackButton, null) },
        React.createElement(DrawerTitle, null, title)))) || React.createElement(Header, { title: title, onClose: onClose }));
};
export default DrawerHeader;
